module.exports = __webpack_public_path__ + "static/media/codeInLogo.b3685be8.png";